import { keymap } from 'prosemirror-keymap';
import type { EditorView } from 'prosemirror-view';

import { WysiwygShortcuts } from '@core/wysiwyg-legacy';

import type { UnderlineSchema } from './underline-mark';
import type { EditorButton, EditorMode, RtPMPlugin } from '../../../editor/types';
import { MarkService, toggleMark } from '../../../helpers/mark-base';
import { DEFAULT_KEYMAP_INPUTRULE_PRIORITY, metaKey } from '../../../helpers/utils';

export class UnderlineService<S extends UnderlineSchema> extends MarkService<S> {}

export class UnderlinePlugin implements RtPMPlugin {
  public api: {
    underlineService: UnderlineService<UnderlineSchema>;
  };
  public buttons = {
    toggleUnderline: <EditorButton>{
      icon: 'format-underlined',
      tooltipText: 'wysiwyg.underline',
      tooltipShortcut: WysiwygShortcuts.Underline(metaKey),
      isActive: (...args) => this.api.underlineService.isActive(...args),
      run: (state, dispatch) => {
        this.api.underlineService.toggle(state, dispatch);
        this.editorView.focus();
      },
    },
  };

  private editorView: EditorView;

  public beforeInit(mode: EditorMode, schema: UnderlineSchema) {
    this.api = {
      underlineService: new UnderlineService(schema.marks.underline),
    };
  }

  public afterInit(mode: EditorMode, editorView: EditorView) {
    this.editorView = editorView;
  }

  public getNativeEditorPlugins(schema: UnderlineSchema) {
    return [
      { priority: DEFAULT_KEYMAP_INPUTRULE_PRIORITY, plugin: keymap(this.getKeyBindings(schema)) },
    ];
  }

  private getKeyBindings(schema: UnderlineSchema) {
    return {
      'Mod-U': toggleMark(schema.marks.underline),
      'Mod-u': toggleMark(schema.marks.underline),
    };
  }
}
